"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FooterOrganisasi() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section id="footerorganisasi" className="bg-background py-24 md:py-32 lg:py-40 border-t border-border relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-accent/10 pointer-events-none" aria-hidden="true" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-5xl mx-auto text-center flex flex-col items-center justify-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl xl:text-7xl font-bold leading-tight md:leading-tight lg:leading-tight tracking-tight">
            <span className="block text-secondary mb-2 md:mb-4">
              SEKALI LAYAR TERKEMBANG
            </span>
            <span className="block text-foreground">
              SURUT KITA BERPANTANG
            </span>
          </h2>
          
          <div className="mt-12 md:mt-16 w-24 h-1 bg-primary rounded-md mx-auto opacity-80" aria-hidden="true" />
        </div>
      </div>
    </section>;
}